(function() {
    'use strict';

    angular
        .module('app.classes.temperatureFunctions', [])
        .service("temperatureFunctionsService", ['$filter', 'xCenterConfig',
            function($filter, xCenterConfig) {
                function selectCorrectTemperature(actualTempArr) {
                    let value = '';
                    let unit = '';

                    if (actualTempArr.length === 1) {
                        value = actualTempArr[0].readValue;
                        unit = actualTempArr[0].DatapointConfig.Unit;
                    }
                    else {
                        let temperatures = $filter('filter')(actualTempArr, equalsGuids('DatapointConfig', 'DatapointConfigId', xCenterConfig.datapointsFloat.Aussentemperatur));

                        if (temperatures.length === 1) {
                            value = temperatures[0].readValue;
                            unit = temperatures[0].DatapointConfig.Unit;
                        }
                        else if (temperatures.length > 1) {
                            let nonZeroTemps = ($filter('orderBy')(temperatures, '-readValue'));
                            value = nonZeroTemps[0].readValue;
                            unit = nonZeroTemps[0].DatapointConfig.Unit;
                        }
                    }

                    return value + ' ' + unit;
                }

                function equalsGuids(prop1, prop2, val) {
                    return function(item){
                        return item[prop1][prop2] === val;
                    };
                }

                return {
                    selectCorrectTemperature: selectCorrectTemperature
                };
            }
        ]);

})();
